/**
 * Suggests a slug from a name, and never overwrites one the user typed.
 *
 * Shared because two screens now need it and the second copy is where the two
 * would start to disagree — and a slug is not cosmetic in this product: a
 * company's is the `{company}` and a project's the `{project}` of the repository
 * name template (`08 §3.1`), so it ends up as a permanent name on somebody
 * else's server.
 *
 * A **suggestion** and not a validator: the server owns the rule, and this only
 * has to produce something plausible while the manager types. Accents are folded
 * rather than dropped (`mañana` → `manana`, not `maana`), which is the same
 * decision the backend name resolver makes with its transliteration table — with
 * the difference that this one runs in a browser whose Unicode support is not in
 * question.
 */
export function slugify(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}
